export default __webpack_public_path__ + "static/media/MenudsjinscampEastMap.d80ead1a.jpg";